<template>
	<div class="container">
		<el-card>
			<div slot="header">水表报表</div>
			<div style="height: 100%">
				<el-tabs v-model="activeName" type="border-card">
					<el-tab-pane label="失联水表报表" name="outControl">
						<div>
							<el-form :model="queryParamsOff" label-width="70px" size="small">
								<el-form-item label="水表编号">
									<el-input v-model="queryParamsOff.meterAddr" class="searchTag" clearable></el-input>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryOffMeter">查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel"
									style="background-color: #23c6c8 !important" size="small"
									@click="exportToExcelOffMeter">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="tableDataOff" style="width: 100%" height="92%"
									id="tableDataOffWaterId">
									<el-table-column type="index" width="60" label="序号" align="center"
										:index="indexMethodOff">
									</el-table-column>
									<el-table-column prop="lesseeCode" label="商户编号" width="200" align="center">
									</el-table-column>
									<el-table-column prop="lesseeName" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="meterAddr" label="水表编号" width="200" align="center">
									</el-table-column>
									<el-table-column prop="detailAddress" label="联系地址" align="center">
									</el-table-column>
									<el-table-column prop="onTime" label="最后在线时间" width="200" align="center">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="totalOff > 0" @size-change="handleQueryOffMeter"
										@current-change="handleQueryOffMeter"
										:current-page.sync="queryParamsOff.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsOff.size"
										layout="total, sizes, prev, pager, next, jumper" :total="totalOff">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表欠费实时报警报表" name="oweRealAlarm">
						<div>
							<el-form :model="queryParamsArrearLast" label-width="80px" size="small">
								<el-form-item label="商户名称" prop="lesseeId" label-width="70px">
									<el-select v-model="queryParamsArrearLast.lesseeId" placeholder="" size="small"
										class="searchTag" clearable filterable>
										<el-option v-for="item in merchantNameOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="告警类型">
									<el-select v-model="queryParamsArrearLast.type" placeholder="请选择" class="searchTag"
										clearable filterable>
										<el-option v-for="item in arrearsTypeOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="推送序列号" label-width="100px">
									<el-input v-model="queryParamsArrearLast.pushSerialNo" class="searchTag" clearable>
									</el-input>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryArrearLast">查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel"
									style="background-color: #23c6c8 !important" size="small"
									@click="exportToExcelArrearLast">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="tableDataArrearLast" style="width: 100%" height="92%"
									id="tableDataArrearLastWaterId">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodArrearLast">
									</el-table-column>
									<el-table-column prop="lesseeCode" label="商户编号" align="center">
									</el-table-column>
									<el-table-column prop="lesseeName" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="type" label="告警类型" align="center">
									</el-table-column>
									<el-table-column prop="editorTime" label="告警时间" align="center">
									</el-table-column>
									<el-table-column prop="limitValue" label="报警阀值" align="center">
									</el-table-column>
									<el-table-column prop="alarmBalance" label="报警时账户余额(元)" width="150" align="center">
									</el-table-column>
									<!-- 	<el-table-column prop="pushContent" label="推送内容" width="130" align="center">
									</el-table-column>
									<el-table-column prop="pushStyle" label="推送方式" width="130" align="center">
									</el-table-column> -->
									<el-table-column prop="pushSerialNo" label="推送序列号" align="center">
									</el-table-column>
									<!-- <el-table-column prop="wxOpenId" label="微信openid" width="150" align="center">
									</el-table-column>
									<el-table-column prop="phone" label="手机号" width="150" align="center">
									</el-table-column> -->
								</el-table>
								<div class="block">
									<el-pagination v-show="totalArrearLast > 0" @size-change="handleQueryArrearLast"
										@current-change="handleQueryArrearLast"
										:current-page.sync="queryParamsArrearLast.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsArrearLast.size"
										layout="total, sizes, prev, pager, next, jumper" :total="totalArrearLast">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表欠费历史报警报表" name="oweHistoryAlarm">
						<div>
							<el-form :model="queryParamsArrear" label-width="80px" size="small">
								<el-form-item label="告警时间">
									<el-date-picker v-model="queryParamsArrear.createStartTime" type="datetime"
										placeholder="选择开始日期" style="width: 182px;" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParamsArrear.createEndTime" type="datetime"
										placeholder="选择结束日期" style="width: 182px;" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="商户名称" prop="lesseeId" label-width="70px">
									<el-select v-model="queryParamsArrear.lesseeId" placeholder="" size="small"
										class="searchTag" clearable filterable>
										<el-option v-for="item in merchantNameOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="告警类型">
									<el-select v-model="queryParamsArrear.type" placeholder="请选择" class="searchTag"
										clearable filterable>
										<el-option v-for="item in arrearsTypeOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="推送序列号" label-width="100px">
									<el-input v-model="queryParamsArrear.pushSerialNo" class="searchTag" clearable
										@keyup.enter.native="handleQueryArrear(true)">
									</el-input>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryArrear(true)">
									查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel"
									style="background-color: #23c6c8 !important" size="small"
									@click="exportToExcelArrear">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="tableDataArrear" style="width: 100%" height="92%"
									id="tableDataArrearWaterId">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodArrear">
									</el-table-column>
									<el-table-column prop="lesseeCode" label="商户编号" align="center">
									</el-table-column>
									<el-table-column prop="lesseeName" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="type" label="告警类型" align="center">
									</el-table-column>
									<el-table-column prop="editorTime" label="告警时间" align="center">
									</el-table-column>
									<el-table-column prop="limitValue" label="报警阀值" align="center">
									</el-table-column>
									<el-table-column prop="alarmBalance" label="报警时账户余额(元)" width="150" align="center">
									</el-table-column>
									<!-- 	<el-table-column prop="pushContent" label="推送内容" width="150" align="center">
									</el-table-column>
									<el-table-column prop="pushStyle" label="推送方式" width="150" align="center">
									</el-table-column> -->
									<el-table-column prop="pushSerialNo" label="推送序列号" align="center">
									</el-table-column>
									<!-- 	<el-table-column prop="wxOpenId" label="微信openid" width="150" align="center">
									</el-table-column>
									<el-table-column prop="phone" label="手机号" width="150" align="center">
									</el-table-column> -->
								</el-table>
								<div class="block">
									<el-pagination v-show="totalArrear > 0" @size-change="handleQueryArrear"
										@current-change="handleQueryArrear"
										:current-page.sync="queryParamsArrear.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsArrear.size"
										layout="total, sizes, prev, pager, next, jumper" :total="totalArrear">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表数据实时报警报表" name="dataRealAlarm">
						<div>
							<el-form :model="queryParamsRealData" label-width="80px" size="small">
								<el-form-item label="商户编号" label-width="70px">
									<el-input v-model="queryParamsRealData.lesseeCode" class="searchTag" clearable>
									</el-input>
								</el-form-item>
								<el-form-item label="商户名称">
									<el-select v-model="queryParamsRealData.name" placeholder="" clearable filterable
										class="searchTag">
										<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
											:value="item.name">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="水表编号">
									<el-select v-model="queryParamsRealData.meterId" placeholder="" size="small"
										clearable filterable class="searchTag">
										<el-option v-for="item in meterIdOption" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="告警类型">
									<el-select v-model="queryParamsRealData.type" placeholder="请选择" size="small"
										clearable filterable class="searchTag">
										<el-option v-for="item in dataAlarmTypeOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryRealData">查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel"
									style="background-color: #23c6c8 !important" size="small"
									@click="exportToExcelRealData">导出</el-button>
							</el-form>
							<div class="tableStyle1">
								<el-table :data="tableDataRealData" style="width: 100%" height="100%"
									id="tableDataRealDataWaterId">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodRealData">
									</el-table-column>
									<el-table-column prop="lesseeCode" label="商户编号" width="160" align="center">
									</el-table-column>
									<el-table-column prop="lesseeName" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="meterAddr" label="水表编号" align="center">
									</el-table-column>
									<el-table-column prop="type" label="告警类型" width="150" align="center">
									</el-table-column>
									<el-table-column prop="editorTime" label="告警时间" align="center">
									</el-table-column>
									<el-table-column prop="alarmStrategyLimitValue" label="报警阀值" width="150"
										align="center">
									</el-table-column>
									<el-table-column prop="alarmValue" label="告警值" width="150" align="center">
									</el-table-column>
									<el-table-column prop="alarmMsg" label="告警提示信息" align="center">
									</el-table-column>
								</el-table>
							</div>
							<div class="block">
								<el-pagination v-show="totalRealData > 0" @size-change="handleQueryRealData"
									@current-change="handleQueryRealData"
									:current-page.sync="queryParamsRealData.current"
									:page-sizes="[100, 200, 400, 600, 800, 1000]"
									:page-size.sync="queryParamsRealData.size"
									layout="total, sizes, prev, pager, next, jumper" :total="totalRealData">
								</el-pagination>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表数据历史报警报表" name="dataHistoryAlarm">
						<div>
							<el-form :model="queryParamsHistoryData" label-width="80px" size="small">
								<el-form-item label="告警时间" label-width="80px">
									<el-date-picker v-model="queryParamsHistoryData.createStartTime" type="datetime"
										placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false" style="width: 182px;">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParamsHistoryData.createEndTime" type="datetime"
										placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false" style="width: 182px;">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="商户编号" label-width="70px">
									<el-input v-model="queryParamsHistoryData.lesseeCode" class="searchTag" clearable
										@keyup.enter.native="handleQueryHistoryData(true)">
									</el-input>
								</el-form-item>
								<el-form-item label="商户名称">
									<el-select v-model="queryParamsHistoryData.name" placeholder="" clearable filterable
										class="searchTag">
										<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
											:value="item.name">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="水表编号">
									<el-select v-model="queryParamsHistoryData.meterId" placeholder="" size="small"
										clearable filterable class="searchTag">
										<el-option v-for="item in meterIdOption" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="告警类型">
									<el-select v-model="queryParamsHistoryData.type" placeholder="请选择" size="small"
										clearable filterable class="searchTag">
										<el-option v-for="item in dataAlarmTypeOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryHistoryData(true)">查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel"
									style="background-color: #23c6c8 !important" size="small"
									@click="exportToExcelHistoryData">导出</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="tableDataHistoryData" style="width: 100%" height="92%"
									id="tableDataHistoryDataWaterId">
									<el-table-column type="index" width="50" label="序号" align="center"
										:index="indexMethodHistoryData">
									</el-table-column>
									<el-table-column prop="lesseeCode" label="商户编号" width="160" align="center">
									</el-table-column>
									<el-table-column prop="lesseeName" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="meterAddr" label="水表编号" align="center">
									</el-table-column>
									<el-table-column prop="type" label="告警类型" width="150" align="center">
									</el-table-column>
									<el-table-column prop="editorTime" label="告警时间" align="center">
									</el-table-column>
									<el-table-column prop="alarmStrategyLimitValue" label="报警阀值" width="150"
										align="center">
									</el-table-column>
									<el-table-column prop="alarmValue" label="告警值" width="150" align="center">
									</el-table-column>
									<el-table-column prop="alarmMsg" label="告警提示信息" align="center">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="totalHistoryData > 0" @size-change="handleQueryHistoryData"
										@current-change="handleQueryHistoryData"
										:current-page.sync="queryParamsHistoryData.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsHistoryData.size"
										layout="total, sizes, prev, pager, next, jumper" :total="totalHistoryData">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull,
		getCurMonthFirstTime,
		getLastMounth
	} from '../../untils/func';
	import {
		selectOffMeterList,
		arrearsSelectList,
		arrearsLastSelectList,
		selectHistoryData,
		selectRealData,
		selectListLesseeName
	} from '../../api/report/waterReport';
	import {
		selectDictionaryListByName,
		selectLessee,
		selectWaterMeter,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import exportTable from '../../untils/exportTable';
	export default {
		data() {
			return {
				form: {},
				activeName: 'outControl',
				// 查询参数
				queryParamsOff: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
				},
				queryParamsArrear: {
					current: 1,
					size: 100,
					createStartTime: getCurMonthFirstTime(),
					createEndTime: getLastMounth(),
				},
				queryParamsArrearLast: {
					current: 1,
					size: 100,
				},
				queryParamsHistoryData: {
					current: 1,
					size: 100,
					createStartTime: getCurMonthFirstTime(),
					createEndTime: getLastMounth(),
				},
				queryParamsRealData: {
					current: 1,
					size: 100,
				},
				// 遮罩层
				loading: true,
				totalOff: 0,
				totalArrear: 0,
				totalArrearLast: 0,
				totalHistoryData: 0,
				totalRealData: 0,
				tableDataOff: [],
				tableDataArrear: [],
				tableDataArrearLast: [],
				tableDataHistoryData: [],
				tableDataRealData: [],

				merchantNameOptions: [],
				arrearsTypeOptions: [], //欠费告警类型options
				dataAlarmTypeOptions: [], //数据告警类型options
				meterIdOption: [], //水表options

				lesseeNameOptions: [],
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQueryOffMeter();
				await this.handleQueryArrear();
				await this.handleQueryArrearLast();
				await this.handleQueryHistoryData();
				await this.handleQueryRealData();

				await this.getSelectLessee();
				await this.getArrearsType();
				await this.getDataAlarmType();
				await this.getSelectMeter();

				await this.getLesseeNameOption();
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListLesseeName(param).then();
				this.lesseeNameOptions = response.data;
			},
			async handleQueryOffMeter() {
				this.loading = true;
				let param = this.queryParamsOff;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectOffMeterList(param).then();
				this.tableDataOff = response.data;
				this.totalOff = response.total;
				this.loading = false;
			},
			async handleQueryArrear(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParamsArrear.current = 1;
				}
				this.loading = true;
				let param = this.queryParamsArrear;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await arrearsSelectList(param).then();
				this.tableDataArrear = response.data;
				this.totalArrear = response.total;
				this.loading = false;
			},
			async handleQueryArrearLast() {
				this.loading = true;
				let param = this.queryParamsArrearLast;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await arrearsLastSelectList(param).then();
				this.tableDataArrearLast = response.data;
				this.totalArrearLast = response.total;
				this.loading = false;
			},
			async handleQueryHistoryData(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParamsHistoryData.current = 1;
				}
				this.loading = true;
				let param = this.queryParamsHistoryData;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectHistoryData(param).then();
				this.tableDataHistoryData = response.data;
				this.totalHistoryData = response.total;
				this.loading = false;
			},
			async handleQueryRealData() {
				this.loading = true;
				let param = this.queryParamsRealData;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectRealData(param).then();
				this.tableDataRealData = response.data;
				this.totalRealData = response.total;
				this.loading = false;
			},
			// 获取商户下拉列表数据
			async getSelectLessee() {
				const res = await selectLessee().then();
				this.merchantNameOptions = res.data;
			},
			// 欠费告警类型下拉框
			async getArrearsType() {
				const res3 = await selectDictionaryListByName(
					dictionaryConstant.ARREARS_ALARM_TYPE
				).then();
				this.arrearsTypeOptions = res3.data;
			},
			// 数据告警类型下拉框
			async getDataAlarmType() {
				const res3 = await selectDictionaryListByName(
					dictionaryConstant.WATER_DATA_ALARM_TYPE
				).then();
				this.dataAlarmTypeOptions = res3.data;
			},
			// 获取水表编号
			async getSelectMeter() {
				const res = await selectWaterMeter().then();
				this.meterIdOption = res.data;
			},
			// 失联水表报表  导出
			async exportToExcelOffMeter() {
				if (this.tableDataOff.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsOff.size;
					this.queryParamsOff.size = this.totalOff;
					this.queryParamsOff.current = 1;
					await this.handleQueryOffMeter();
					exportTable.exportExcel('tableDataOffWaterId', '失联水表报表');
					this.queryParamsOff.size = size;
					await this.handleQueryOffMeter();
				}
			},
			// 水表欠费实时报警报表  导出
			async exportToExcelArrearLast() {
				if (this.tableDataArrearLast.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsArrearLast.size;
					this.queryParamsArrearLast.size = this.totalArrearLast;
					this.queryParamsArrearLast.current = 1;
					await this.handleQueryArrearLast();
					exportTable.exportExcel(
						'tableDataArrearLastWaterId',
						'水表欠费实时报警报表'
					);
					this.queryParamsArrearLast.size = size;
					await this.handleQueryArrearLast();
				}
			},
			// 水表欠费历史报警报表  导出
			async exportToExcelArrear() {
				if (this.tableDataArrear.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsArrear.size;
					this.queryParamsArrear.size = this.totalArrear;
					this.queryParamsArrear.current = 1;
					await this.handleQueryArrear();
					exportTable.exportExcel(
						'tableDataArrearWaterId',
						'水表欠费历史报警报表'
					);
					this.queryParamsArrear.size = size;
					await this.handleQueryArrear();
				}
			},
			// 水表数据实时报警报表  导出
			async exportToExcelRealData() {
				if (this.tableDataRealData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsRealData.size;
					this.queryParamsRealData.size = this.totalRealData;
					this.queryParamsRealData.current = 1;
					await this.handleQueryRealData();
					exportTable.exportExcel(
						'tableDataRealDataWaterId',
						'水表数据实时报警报表'
					);
					this.queryParamsRealData.size = size;
					await this.handleQueryRealData();
				}
			},
			// 水表数据历史报警报表  导出
			async exportToExcelHistoryData() {
				if (this.tableDataHistoryData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParamsHistoryData.size;
					this.queryParamsHistoryData.size = this.totalHistoryData;
					this.queryParamsHistoryData.current = 1;
					await this.handleQueryHistoryData();
					exportTable.exportExcel(
						'tableDataHistoryDataWaterId',
						'水表数据历史报警报表'
					);
					this.queryParamsHistoryData.size = size;
					await this.handleQueryHistoryData();
				}
			},
			indexMethodOff(index) {
				let num =
					this.queryParamsOff.size * (this.queryParamsOff.current - 1) +
					index +
					1;
				return num;
			},
			indexMethodArrearLast(index) {
				let num =
					this.queryParamsArrearLast.size *
					(this.queryParamsArrearLast.current - 1) +
					index +
					1;
				return num;
			},
			indexMethodArrear(index) {
				let num =
					this.queryParamsArrear.size * (this.queryParamsArrear.current - 1) +
					index +
					1;
				return num;
			},
			indexMethodRealData(index) {
				let num =
					this.queryParamsRealData.size * (this.queryParamsRealData.current - 1) +
					index +
					1;
				return num;
			},
			indexMethodHistoryData(index) {
				let num =
					this.queryParamsHistoryData.size *
					(this.queryParamsHistoryData.current - 1) +
					index +
					1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
		margin-bottom: 10px;
	}

	.searchTag {
		width: 160px;
	}

	/deep/ .el-tabs {
		height: 100% !important;

		.el-tabs__content {
			height: calc(100% - 39px);
		}
	}

	.el-button {
		margin-left: 10px;
	}

	.tableStyle {
		height: calc(100vh - 322px);
	}

	.tableStyle1 {
		height: calc(100vh - 334px);
	}

	// @media screen and (max-width: 1400px) {
	//   .tableStyle {
	//     height: calc(100vh - 450px);
	//   }
	// }
	.block {
		margin-top: 10px;
	}
</style>
